//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import { ToastWarning } from "./../utils/helpers";
import usersAPI from "./../apis/users";

export default {
  name: "Following",
  data() {
    return {
      users: [],
    };
  },
  props: {
    initialUpdate: {
      type: Boolean,
      required: true,
    },
  },
  mounted() {
    this.fetchFollowing();
  },
  watch: {
    initialUpdate: function () {
      this.fetchFollowing();
    },
  },
  methods: {
    async fetchFollowing() {
      try {
        const id = this.$route.params.id;
        const response = await usersAPI.getUserFollowing(id);
        console.log(response.data);
        this.users = response.data;
      } catch (error) {
        console.error(error);
      }
    },
    async deleteFollow(userId) {
      try {
        const { data } = await usersAPI.deleteFollow({ userId });
        console.log(data);
        this.users = this.users.map((user) => {
          if (user.id !== userId) {
            return user;
          } else {
            return {
              ...user,
              isFollowed: false,
            };
          }
        });
        this.fetchFollowing();
        this.$emit("update-popular");
      } catch (error) {
        console.log(error);
      }
    },
    async addFollow(id) {
      try {
        const { data } = await usersAPI.addFollow({ id });
        console.log(data);
        this.users = this.users.map((user) => {
          if (user.id !== id) {
            return user;
          } else {
            return {
              ...user,
              isFollowed: true,
            };
          }
        });
        this.fetchFollowing();
        this.$emit("update-popular");
      } catch (error) {
        console.log(error);
      }
    },
    // addFollow() {
    //   this.user.isFollowing = true;
    // },
    // deleteFollow() {
    //   ToastWarning.fire({
    //     title: "確定要取消追蹤嗎?",
    //     // text: "You won't be able to revert this!",
    //     icon: "warning",
    //     showCancelButton: false,
    //     confirmButtonColor: "#3085d6",
    //     cancelButtonColor: "#d33",
    //     confirmButtonText: "是",
    //   }).then((result) => {
    //     if (result.isConfirmed) {
    //       ToastWarning.fire("OK!", "已經取消追蹤", "success");
    //       this.user.isFollowing = false;
    //     }
    //   });
    // },
  },
};
